(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7bbe"];
var parcelRegister = parcelRequire.register;
parcelRegister("3xYha", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "ObjectPage", function () { return $f30a64cff0b3f76e$export$e951d7e8878ee8da; });
$parcel$export(module.exports, "default", function () { return $f30a64cff0b3f76e$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $67EyS = parcelRequire("67EyS");

var $5ABEx = parcelRequire("5ABEx");

var $fEaOX = parcelRequire("fEaOX");

var $l2vbS = parcelRequire("l2vbS");

var $kj1UN = parcelRequire("kj1UN");

var $eUjUM = parcelRequire("eUjUM");

var $c9YBN = parcelRequire("c9YBN");

var $eS5ey = parcelRequire("eS5ey");

var $lno0h = parcelRequire("lno0h");

var $84aXW = parcelRequire("84aXW");

var $7IEX2 = parcelRequire("7IEX2");

var $7ky0J = parcelRequire("7ky0J");

var $9xVId = parcelRequire("9xVId");

var $8fUOS = parcelRequire("8fUOS");

var $aZDKU = parcelRequire("aZDKU");

var $cUbQm = parcelRequire("cUbQm");

var $dIKI1 = parcelRequire("dIKI1");

var $kcxrH = parcelRequire("kcxrH");

var $lQsIr = parcelRequire("lQsIr");

const $f30a64cff0b3f76e$var$ObjectNavigationMobile = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("dIdpD")));

const $f30a64cff0b3f76e$var$IntroDescription = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("3b1hD")));

const $f30a64cff0b3f76e$var$ObjectMovie = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("3lBXD")));

const $f30a64cff0b3f76e$var$ObjectImageGrid = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("hngVL")));

const $f30a64cff0b3f76e$var$ButtonMenu = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("jcWdT")));

const $f30a64cff0b3f76e$var$ObjectBreadCrumbs = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("4YHAd")));

const $f30a64cff0b3f76e$var$BoneoImage = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("hxN19")));

const $f30a64cff0b3f76e$var$ObjectTables = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("kXuE5")));

const $f30a64cff0b3f76e$var$ObjectDescriptionApproval = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("2z9Eg")));

const $f30a64cff0b3f76e$var$SoldObjectPartials = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("6PO0X")));

const $f30a64cff0b3f76e$var$DataLayerObject = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("bIXEH")));

const $f30a64cff0b3f76e$var$Econans = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("2xmJq")));

const $f30a64cff0b3f76e$var$MapAndBroker = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("8KLDQ")));

const $f30a64cff0b3f76e$var$ObjectServices = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("le8N8")));

const $f30a64cff0b3f76e$var$BankPuff = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("4DL9G")));
const $f30a64cff0b3f76e$export$e951d7e8878ee8da = ({ objectId: objectId, evaluateHeadline: evaluateHeadline, evaluateText: evaluateText, evaluateLeadsource: evaluateLeadsource, intake: intake, sellPageText: sellPageText, textNotApproved: textNotApproved, headlineNotApproved: headlineNotApproved, preview: preview, econansInterest: econansInterest, mediaView: mediaView })=>{
    const isBigScreen = (0, $67EyS.default)("(min-width: 64rem)");
    const { data: estate, isLoading: isLoading } = (0, $aZDKU.default)(objectId, intake);
    const [ref, inView] = (0, $dIKI1.useInView)();
    const [refImgGrid, inViewImgGrid] = (0, $dIKI1.useInView)();
    const [refImgGridDesktop, inViewImgGridDesktop] = (0, $dIKI1.useInView)();
    const [refBoneo, inViewBoneo] = (0, $dIKI1.useInView)();
    const [refServices, inViewServices] = (0, $dIKI1.useInView)();
    const [refBtn, inViewBtn] = (0, $dIKI1.useInView)();
    const [refBread, inViewBread] = (0, $dIKI1.useInView)();
    const [refDesc, inViewDesc] = (0, $dIKI1.useInView)();
    const [refMovieDesktop, inViewMovieDesktop] = (0, $dIKI1.useInView)();
    const [refMovieMobile, inViewMovieMobile] = (0, $dIKI1.useInView)();
    const [gridLoaded, setGridLoaded] = (0, $dTCkE.useState)(false);
    const [mapLoaded, setMapLoaded] = (0, $dTCkE.useState)(false);
    const [boneoLoaded, setBoneoLoaded] = (0, $dTCkE.useState)(false);
    const [servicesLoaded, setServicesLoaded] = (0, $dTCkE.useState)(false);
    const [btnLoaded, setBtnLoaded] = (0, $dTCkE.useState)(false);
    const [breadLoaded, setBreadLoaded] = (0, $dTCkE.useState)(false);
    const [descLoaded, setDescLoaded] = (0, $dTCkE.useState)(false);
    const [movieLoaded, setMovieLoaded] = (0, $dTCkE.useState)(false);
    const movieView = estate?.links.filter((link)=>link?.category && link.category.toLowerCase().indexOf("film") > -1);
    if (isLoading || isBigScreen === undefined || mediaView === null) return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "top-0 left-0 z-9 fixed bg-grey50 w-full h-full"
    });
    if (!isLoading && !estate) window.location.replace("/objektet-ar-borttaget/");
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kqTTL.default), {
        objectId: objectId,
        intake: intake,
        isLoading: isLoading,
        estateItem: estate,
        isBigScreen: isBigScreen,
        children: isBigScreen !== undefined ? /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "lg:relative lg:grid object-grid-container mx-auto mb-8 lg:mb-0 max-w-10xl",
            children: [
                !isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5ABEx.default), {}),
                /*#__PURE__*/ (0, $a9eYm.jsx)((0, $9xVId.default), {}),
                /*#__PURE__*/ (0, $a9eYm.jsxs)("main", {
                    id: "main-left",
                    className: "relative main-left lg:pb-8",
                    children: [
                        isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5ABEx.default), {}),
                        isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            className: "mx-auto max-w-7xl",
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)((0, $fEaOX.default), {}),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refDesc,
                                    children: descLoaded || inViewDesc && !descLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $l2vbS.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$IntroDescription, {
                                            setDescLoaded: setDescLoaded
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $l2vbS.default), {})
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refBtn,
                                    children: btnLoaded || inViewBtn && !btnLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $c9YBN.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ButtonMenu, {
                                            setBtnLoaded: setBtnLoaded
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $c9YBN.default), {})
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refBread,
                                    children: breadLoaded || inViewBread && !breadLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kcxrH.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectBreadCrumbs, {
                                            setBreadLoaded: setBreadLoaded
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kcxrH.default), {})
                                }),
                                estate?.econansReady && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $8fUOS.default), {}),
                                estate?.status?.id != (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lQsIr.default), {}) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                estate?.status?.name !== (0, $cUbQm.EstateStatuses).SoldOut && (estate?.housingCooperatives || estate?.houses || estate?.plots || estate?.cottages) ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectTables, {})
                                }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                movieView && movieView.length > 0 ? /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refMovieDesktop,
                                    children: movieLoaded || inViewMovieDesktop && !movieLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $7ky0J.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectMovie, {
                                            setMovieLoaded: setMovieLoaded,
                                            movieView: movieView
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $7ky0J.default), {})
                                }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refImgGridDesktop,
                                    children: gridLoaded || inViewImgGridDesktop && !gridLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eUjUM.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectImageGrid, {
                                            setGridLoaded: setGridLoaded
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eUjUM.default), {})
                                })
                            ]
                        }),
                        !isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            className: "px-3",
                            children: [
                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refBread,
                                    children: breadLoaded || inViewBread && !breadLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kcxrH.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectBreadCrumbs, {
                                            setBreadLoaded: setBreadLoaded
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kcxrH.default), {})
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $l2vbS.default), {}),
                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$IntroDescription, {
                                        setDescLoaded: setDescLoaded
                                    })
                                }),
                                estate?.econansReady && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $8fUOS.default), {}),
                                estate?.status?.id != (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lQsIr.default), {}) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                estate?.status?.name !== (0, $cUbQm.EstateStatuses).SoldOut && (estate?.housingCooperatives || estate?.houses || estate?.plots || estate?.cottages) ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectTables, {})
                                }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                movieView && movieView.length > 0 ? /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refMovieMobile,
                                    children: movieLoaded || inViewMovieMobile && !movieLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $7ky0J.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectMovie, {
                                            setMovieLoaded: setMovieLoaded,
                                            movieView: movieView
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $7ky0J.default), {})
                                }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    ref: refImgGrid,
                                    children: gridLoaded || inViewImgGrid && !gridLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                        fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eUjUM.default), {}),
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectImageGrid, {
                                            setGridLoaded: setGridLoaded
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eUjUM.default), {})
                                })
                            ]
                        }),
                        preview === "true" && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectDescriptionApproval, {
                                sellPageText: sellPageText,
                                textNotApproved: textNotApproved,
                                headlineNotApproved: headlineNotApproved
                            })
                        }),
                        !estate?.isForSaleOrHeadStart && estate?.status?.name == (0, $cUbQm.EstateStatuses).Sold && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$SoldObjectPartials, {})
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            ref: ref,
                            children: mapLoaded || inView && !mapLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kj1UN.default), {}),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$MapAndBroker, {
                                    evaluateLeadsource: evaluateLeadsource,
                                    evaluateHeadline: evaluateHeadline,
                                    evaluateText: evaluateText,
                                    setMapLoaded: setMapLoaded
                                })
                            }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kj1UN.default), {})
                        }),
                        estate?.isGreenEstate || estate?.isHeadStart || estate?.inspected ? /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            id: "serviceItems",
                            ref: refServices,
                            children: servicesLoaded || inViewServices && !servicesLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lno0h.default), {}),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectServices, {
                                    setServicesLoaded: setServicesLoaded
                                })
                            }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $lno0h.default), {})
                        }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                        estate?.econansReady ? /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            id: "evaluate-section",
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $7IEX2.default), {}),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$Econans, {
                                    interest: econansInterest
                                })
                            })
                        }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                        estate?.estateTypeAsString !== (0, $cUbQm.EstateType).Commercial && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            ref: refBoneo,
                            children: boneoLoaded || inViewBoneo && !boneoLoaded ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $84aXW.default), {}),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$BoneoImage, {
                                    fullMargin: true,
                                    setBoneoLoaded: setBoneoLoaded
                                })
                            }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $84aXW.default), {})
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$BankPuff, {})
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$DataLayerObject, {})
                        })
                    ]
                }),
                isBigScreen === false && estate?.status?.id !== (0, $cUbQm.StatusId).Sold && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                    fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eS5ey.default), {}),
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($f30a64cff0b3f76e$var$ObjectNavigationMobile, {})
                })
            ]
        }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {})
    });
};
var $f30a64cff0b3f76e$export$2e2bcd8739ae039 = $f30a64cff0b3f76e$export$e951d7e8878ee8da;

});
parcelRegister("kqTTL", function(module, exports) {

$parcel$export(module.exports, "ObjectPageContext", function () { return $75519ccb2683d5da$export$a8135b54c6322f9a; });
$parcel$export(module.exports, "default", function () { return $75519ccb2683d5da$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $1A7pc = parcelRequire("1A7pc");

var $dTCkE = parcelRequire("dTCkE");

var $67EyS = parcelRequire("67EyS");

var $l8eky = parcelRequire("l8eky");
const $75519ccb2683d5da$export$a8135b54c6322f9a = /*#__PURE__*/ (0, $dTCkE.createContext)({});
const $75519ccb2683d5da$var$ObjectPageContextProvider = ({ children: children, objectId: objectId, intake: intake, estateItem: estateItem, isLoading: isLoading, isBigScreen: isBigScreen })=>{
    const sessionId = (0, $l8eky.getSessionId)();
    const [mediaView, setMediaView] = (0, $dTCkE.useState)(null);
    const [oneViewing, setOneViewing] = (0, $dTCkE.useState)(false);
    const [mediaOption, setMediaOption] = (0, $dTCkE.useState)("imageView");
    const [accordionOption, setAccordionOption] = (0, $dTCkE.useState)("");
    const [isAuthorizedBroker, setIsAuthorizedBroker] = (0, $dTCkE.useState)(false);
    const isMediumScreen = (0, $67EyS.default)("(min-width: 46rem)");
    const isSmallScreen = (0, $67EyS.default)("(max-width: 32rem)");
    const [showErrorObjectPage, setShowErrorObjectPage] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        if (estateItem === null && !isLoading) window.location.replace("/objektet-ar-borttaget/");
    }, [
        estateItem,
        isLoading
    ]);
    function imageViewChoice() {
        var url = window.location.href;
        if (url.indexOf("imageView") > -1) {
            setMediaOption("imageView");
            setMediaView(true);
        } else if (url.indexOf("constructPlan") > -1) {
            setMediaOption("constructPlan");
            setMediaView(true);
        } else if (url.indexOf("movieView") > -1) {
            setMediaOption("movieView");
            setMediaView(true);
        } else if (url.indexOf("3DView") > -1) {
            setMediaOption("3DView");
            setMediaView(true);
        } else if (url.indexOf("heliView") > -1) {
            setMediaOption("heliView");
            setMediaView(true);
        } else {
            setMediaView(false);
            setMediaOption("imageView");
        }
    }
    (0, $dTCkE.useEffect)(()=>{
        imageViewChoice();
    }, [
        objectId,
        window.history
    ]);
    (0, $dTCkE.useEffect)(()=>{
        window.onpopstate = (e)=>{
            imageViewChoice();
        };
    });
    (0, $dTCkE.useEffect)(()=>{
        var loginType = (0, (/*@__PURE__*/$parcel$interopDefault($1A7pc))).get("loginType");
        setIsAuthorizedBroker(loginType === "2");
    }, [
        isLoading
    ]);
    const contextObject = {
        mediaView: mediaView,
        setMediaView: setMediaView,
        mediaOption: mediaOption,
        setMediaOption: setMediaOption,
        accordionOption: accordionOption,
        setAccordionOption: setAccordionOption,
        objectId: objectId,
        intake: intake,
        sessionId: sessionId,
        estate: estateItem,
        isLoading: isLoading,
        isAuthorizedBroker: isAuthorizedBroker,
        showErrorObjectPage: showErrorObjectPage,
        setShowErrorObjectPage: setShowErrorObjectPage,
        oneViewing: oneViewing,
        setOneViewing: setOneViewing,
        isBigScreen: isBigScreen,
        isMediumScreen: isMediumScreen,
        isSmallScreen: isSmallScreen
    };
    return /*#__PURE__*/ (0, $a9eYm.jsx)($75519ccb2683d5da$export$a8135b54c6322f9a.Provider, {
        value: contextObject,
        children: children
    });
};
var $75519ccb2683d5da$export$2e2bcd8739ae039 = $75519ccb2683d5da$var$ObjectPageContextProvider;

});
parcelRegister("1A7pc", function(module, exports) {
(function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /* eslint-disable no-var */ function assign(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)target[key] = source[key];
        }
        return target;
    }
    /* eslint-enable no-var */ /* eslint-disable no-var */ var defaultConverter = {
        read: function(value) {
            if (value[0] === '"') value = value.slice(1, -1);
            return value.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
        },
        write: function(value) {
            return encodeURIComponent(value).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
        }
    };
    /* eslint-enable no-var */ /* eslint-disable no-var */ function init(converter, defaultAttributes) {
        function set(name, value, attributes) {
            if (typeof document === "undefined") return;
            attributes = assign({}, defaultAttributes, attributes);
            if (typeof attributes.expires === "number") attributes.expires = new Date(Date.now() + attributes.expires * 864e5);
            if (attributes.expires) attributes.expires = attributes.expires.toUTCString();
            name = encodeURIComponent(name).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
            var stringifiedAttributes = "";
            for(var attributeName in attributes){
                if (!attributes[attributeName]) continue;
                stringifiedAttributes += "; " + attributeName;
                if (attributes[attributeName] === true) continue;
                // Considers RFC 6265 section 5.2:
                // ...
                // 3.  If the remaining unparsed-attributes contains a %x3B (";")
                //     character:
                // Consume the characters of the unparsed-attributes up to,
                // not including, the first %x3B (";") character.
                // ...
                stringifiedAttributes += "=" + attributes[attributeName].split(";")[0];
            }
            return document.cookie = name + "=" + converter.write(value, name) + stringifiedAttributes;
        }
        function get(name) {
            if (typeof document === "undefined" || arguments.length && !name) return;
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all.
            var cookies = document.cookie ? document.cookie.split("; ") : [];
            var jar = {};
            for(var i = 0; i < cookies.length; i++){
                var parts = cookies[i].split("=");
                var value = parts.slice(1).join("=");
                try {
                    var found = decodeURIComponent(parts[0]);
                    jar[found] = converter.read(value, found);
                    if (name === found) break;
                } catch (e) {}
            }
            return name ? jar[name] : jar;
        }
        return Object.create({
            set: set,
            get: get,
            remove: function(name, attributes) {
                set(name, "", assign({}, attributes, {
                    expires: -1
                }));
            },
            withAttributes: function(attributes) {
                return init(this.converter, assign({}, this.attributes, attributes));
            },
            withConverter: function(converter) {
                return init(assign({}, this.converter, converter), this.attributes);
            }
        }, {
            attributes: {
                value: Object.freeze(defaultAttributes)
            },
            converter: {
                value: Object.freeze(converter)
            }
        });
    }
    var api = init(defaultConverter, {
        path: "/"
    });
    /* eslint-enable no-var */ return api;
});

});

parcelRegister("67EyS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23722fec40a37891$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");
const $23722fec40a37891$var$useMediaQuery = (query)=>{
    const [matches, setMatches] = (0, $dTCkE.useState)();
    (0, $dTCkE.useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) setMatches(media.matches);
        const listener = ()=>setMatches(media.matches);
        media.addEventListener("change", listener);
        return ()=>media.removeEventListener("change", listener);
    }, [
        query,
        matches
    ]);
    return matches;
};
var $23722fec40a37891$export$2e2bcd8739ae039 = $23722fec40a37891$var$useMediaQuery;

});


parcelRegister("5ABEx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d9ec65ac1b3e7b90$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $awtH3 = parcelRequire("awtH3");

var $kKHx5 = parcelRequire("kKHx5");

var $5w0D2 = parcelRequire("5w0D2");

const $d9ec65ac1b3e7b90$var$ReturnButton = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("lGNl1")));
const $d9ec65ac1b3e7b90$var$ObjectHero = ()=>{
    const { setMediaView: setMediaView, setMediaOption: setMediaOption, objectId: objectId, estate: estate, mediaView: mediaView } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $awtH3.Router), {
        location: "",
        navigator: undefined,
        children: [
            estate?.projectId && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($d9ec65ac1b3e7b90$var$ReturnButton, {
                    link: `/till-salu?objectId=${estate?.projectId}`,
                    label: "Till projektet"
                })
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kKHx5.default), {}),
            mediaView && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5w0D2.default), {})
        ]
    });
};
var $d9ec65ac1b3e7b90$export$2e2bcd8739ae039 = $d9ec65ac1b3e7b90$var$ObjectHero;

});
parcelRegister("kKHx5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4edbda3de54e3ab$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $1oa4x = parcelRequire("1oa4x");

var $kqTTL = parcelRequire("kqTTL");

var $67EyS = parcelRequire("67EyS");

const $e4edbda3de54e3ab$var$LoadAllImages = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("9bXAB")));
const $e4edbda3de54e3ab$var$ImageSlider = ()=>{
    const [imageIndex, setImageIndex] = (0, $dTCkE.useState)(0);
    const { setMediaView: setMediaView, estate: data } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const isMediumScreen = (0, $67EyS.default)("(min-width: 32rem)");
    function setMediaOptionView(id) {
        setMediaView(true);
        const newUrl = window.location.href + "#" + id;
        window.location.href = newUrl;
    }
    const nextImage = ()=>{
        setImageIndex((imageIndex + 1) % (data?.images?.length > 10 ? 11 : Object.keys(data?.images)?.length));
    };
    const prevImage = ()=>{
        setImageIndex(imageIndex === 0 ? (data?.images?.length > 10 ? 11 : Object.keys(data?.images)?.length) - 1 : imageIndex - 1);
    };
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex flex-col items-center justify-center overflow-hidden w-full h-[250px] md:h-screen/2 lg:h-[76vh] max-h-3.5xl relative",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                style: {
                    transform: `translateX(-${imageIndex * 100}%)`
                },
                className: "flex w-full h-full transition ease-out duration-700",
                children: [
                    isMediumScreen && /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                        children: [
                            data?.images?.slice(0, 10).map((image, index)=>{
                                return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    onClick: ()=>setMediaOptionView("imageView"),
                                    className: "cursor-pointer flex justify-center items-center flex-[0_0_100%]",
                                    children: index === 0 ? /*#__PURE__*/ (0, $a9eYm.jsx)("picture", {
                                        className: "w-full h-full",
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                            width: 1000,
                                            height: 680,
                                            className: "w-full h-full object-cover",
                                            src: image?.path,
                                            alt: data?.addressInfo?.streetAddress,
                                            sizes: "(max-width: 1440px) 100vw, 1440px",
                                            loading: "eager"
                                        })
                                    }) : /*#__PURE__*/ (0, $a9eYm.jsx)("picture", {
                                        className: "w-full h-full",
                                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                            width: 1000,
                                            height: 680,
                                            src: image?.path,
                                            alt: data?.addressInfo?.streetAddress,
                                            className: "w-full h-full object-cover",
                                            loading: `lazy`
                                        })
                                    })
                                }, index);
                            }),
                            data?.images?.length > 10 && imageIndex > 8 && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($e4edbda3de54e3ab$var$LoadAllImages, {})
                            })
                        ]
                    }),
                    !isMediumScreen && data?.images[0]?.path && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        onClick: ()=>setMediaOptionView("imageView"),
                        className: "cursor-pointer flex justify-center items-center flex-[0_0_100%] min-h-[250px]",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("picture", {
                            className: "w-full h-full",
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                loading: "eager",
                                width: 700,
                                height: 400,
                                className: "w-full h-full object-cover",
                                src: data?.images[0]?.mobilePath,
                                alt: data?.addressInfo?.streetAddress
                            })
                        })
                    })
                ]
            }),
            !isMediumScreen && /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                onClick: ()=>setMediaOptionView("imageView"),
                "aria-label": "Visa bildvy",
                src: "/Images/Icons/two-images.svg",
                alt: "ikon",
                loading: "lazy",
                className: "absolute top-4 right-4 ml-3 h-7 lg:h-10 w-auto",
                width: 36,
                height: 28
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                onClick: ()=>setMediaOptionView("imageView"),
                className: "absolute bottom-0 left-0 w-full h-2/3 mdplus:h-1/3 bg-linear-gradient cursor-pointer"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "absolute bottom-0 left-1/2 -translate-x-1/2 px-2 lg:px-7 xxl:px-4 py-4 lg:pb-6 xxl:pb-8 w-full max-w-7xl flex justify-between items-end",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)((0, $1oa4x.default), {}),
                    isMediumScreen && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "gap-2 lg:gap-4 px-2 lg:px-0 pb-0 lg:pb-3 min-w-10 lg:min-w-[12rem] hidden lg:flex",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                                className: "flex items-center justify-center w-8 lg:w-11 h-8 lg:h-11 rounded-round border-white border-2",
                                onClick: prevImage,
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                    width: "24",
                                    height: "12",
                                    src: "/Images/Icons/Arrows/arrow-right-white.svg",
                                    alt: "Ikon f\xf6reg\xe5ende bild",
                                    className: "w-4 lg:w-6 h-auto rotate-180",
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                                className: "flex items-center justify-center w-8 lg:w-11 h-8 lg:h-11 rounded-round border-white border-2",
                                onClick: nextImage,
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                    width: "24",
                                    height: "12",
                                    src: "/Images/Icons/Arrows/arrow-right-white.svg",
                                    alt: "Ikon n\xe4sta bild",
                                    className: "w-4 lg:w-6 h-auto",
                                    loading: "lazy"
                                })
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                                onClick: ()=>setMediaOptionView("imageView"),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                    width: "52",
                                    height: "40",
                                    src: "/Images/Icons/two-images.svg",
                                    alt: "Ikon bildvisning",
                                    className: "ml-3 h-7 lg:h-10 w-auto",
                                    loading: "lazy"
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var $e4edbda3de54e3ab$export$2e2bcd8739ae039 = $e4edbda3de54e3ab$var$ImageSlider;

});
parcelRegister("1oa4x", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7c6cb6df41a6c24d$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $cIgkl = parcelRequire("cIgkl");

var $hBoXS = parcelRequire("hBoXS");

var $9zBK0 = parcelRequire("9zBK0");

var $cUbQm = parcelRequire("cUbQm");
const $7c6cb6df41a6c24d$var$ObjectHeroInformation = ()=>{
    const { estate: data } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const longAdressInfo = data?.addressInfo?.city?.length + data?.addressInfo?.area?.length > 40 ? true : false;
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex flex-col text-white font-ic lg:max-w-4/5 w-full min-w-[320px]",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "relative w-auto self-start mb-2 lg:mb-3 pr-8",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                        className: `text-base lg:text-lg xl:text-xl ${longAdressInfo ? "" : "whitespace-nowrap"}`,
                        children: [
                            data?.addressInfo?.city,
                            data?.addressInfo?.city && data?.addressInfo?.area && data?.addressInfo?.area && data?.addressInfo?.area.toLowerCase() != data?.addressInfo?.city.toLowerCase() ? " - " : "",
                            data?.addressInfo?.area && data?.addressInfo?.area.toLowerCase() != data?.addressInfo?.city.toLowerCase() ? data?.addressInfo?.area : ""
                        ]
                    }),
                    data?.estateTypeAsString === (0, $cUbQm.EstateType).Project && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $cIgkl.default), {}),
                    data?.estateTypeAsString === (0, $cUbQm.EstateType).Commercial && data?.isForSaleOrHeadStart && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $hBoXS.default), {}),
                    data?.status?.id == (0, $cUbQm.StatusId).Sold && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $9zBK0.default), {})
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("h1", {
                className: `font-lf text-3xl lg:text-5xl leading-7 md:leading-9 lg:leading-12 mb-3 lg:mb-4 w-fit lg:max-w-4/5`,
                children: [
                    data?.estateTypeAsString === (0, $cUbQm.EstateType).Project && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
                        children: data?.projectName
                    }),
                    data?.estateTypeAsString !== (0, $cUbQm.EstateType).Project && data?.addressInfo?.streetAddress && data?.addressInfo?.streetAddress !== "-" && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
                        children: data?.addressInfo?.streetAddress
                    })
                ]
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "flex flex-wrap",
                children: [
                    data?.isHeadStart && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex flex-row gap-2 hero-service",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                            onClick: ()=>{
                                document.getElementById("serviceItems").scrollIntoView({
                                    block: "center",
                                    behavior: "smooth"
                                });
                            },
                            className: "header-info-item mdplus:text-lg hover:underline cursor-pointer font-ic",
                            children: "Kommande f\xf6rs\xe4ljning"
                        })
                    }),
                    data?.inspected && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex flex-row gap-2 hero-service",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                            onClick: ()=>{
                                document.getElementById("serviceItems").scrollIntoView({
                                    block: "center",
                                    behavior: "smooth"
                                });
                            },
                            className: "header-info-item mdplus:text-lg hover:underline cursor-pointer font-ic",
                            children: (0, $cUbQm.Estates).LDPlus
                        })
                    }),
                    data?.isGreenEstate && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex flex-row gap-2 hero-service",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                            onClick: ()=>{
                                document.getElementById("serviceItems").scrollIntoView({
                                    block: "center",
                                    behavior: "smooth"
                                });
                            },
                            className: "header-info-item mdplus:text-lg hover:underline cursor-pointer font-ic",
                            children: (0, $cUbQm.ServicesTitles).GreenEstate
                        })
                    })
                ]
            })
        ]
    });
};
var $7c6cb6df41a6c24d$export$2e2bcd8739ae039 = $7c6cb6df41a6c24d$var$ObjectHeroInformation;

});
parcelRegister("cIgkl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d91047baff3e234d$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $d91047baff3e234d$var$NewProdLabel = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: `flex items-center justify-center w-fit bg-blue300 text-white py-[2px] md:py-1 px-2 md:px-4 rounded-[3px] md:text-xs absolute bottom-8 left-[72%]`,
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                    className: "text-sm font-icb",
                    children: "Nyproduktion"
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "inline-block object-triangle absolute bottom-0 lg:-bottom-[3px] left-0 transform translate-y-1/1"
                })
            ]
        })
    });
};
var $d91047baff3e234d$export$2e2bcd8739ae039 = $d91047baff3e234d$var$NewProdLabel;

});

parcelRegister("hBoXS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b8e7857d26b3db5$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $4b8e7857d26b3db5$var$CommercialLabel = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: `flex items-center justify-center w-fit bg-black500 text-white py-[2px] md:py-1 px-2 md:px-4 rounded-[3px] absolute md:text-xs bottom-8 left-[72%]`,
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                    className: "text-sm font-icb",
                    children: "Kommersiellt"
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "inline-block object-triangle commercial absolute bottom-0 lg:-bottom-[4px] left-0 transform translate-y-1/1"
                })
            ]
        })
    });
};
var $4b8e7857d26b3db5$export$2e2bcd8739ae039 = $4b8e7857d26b3db5$var$CommercialLabel;

});

parcelRegister("9zBK0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6559c9b53b2329a6$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $6559c9b53b2329a6$var$SoldLabel = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: `flex items-center justify-center w-fit bg-red200  text-white py-[2px] md:py-1 px-2 md:px-4 rounded-[3px] absolute md:text-xs bottom-8 left-[72%]`,
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                    className: "text-sm font-icb",
                    children: "S\xe5ld"
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "inline-block object-triangle sold absolute bottom-0 lg:-bottom-[4px] left-0 transform translate-y-1/1"
                })
            ]
        })
    });
};
var $6559c9b53b2329a6$export$2e2bcd8739ae039 = $6559c9b53b2329a6$var$SoldLabel;

});


parcelRegister("9bXAB", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("12ZXd")).then(()=>parcelRequire("5AVP8"));

});


parcelRegister("5w0D2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $15c1082192441aed$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $dkX7e = parcelRequire("dkX7e");

var $ki08P = parcelRequire("ki08P");

var $iAiYW = parcelRequire("iAiYW");

var $9Ofhh = parcelRequire("9Ofhh");

var $b2sNg = parcelRequire("b2sNg");

const $15c1082192441aed$var$MediaView3D = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("5W42d")));

const $15c1082192441aed$var$MediaViewHeli = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("lIzqO")));

const $15c1082192441aed$var$MediaPlayer = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("fR3P5")));
const $15c1082192441aed$var$MediaContainer = ()=>{
    const { mediaOption: mediaOption, setMediaOption: setMediaOption, mediaView: mediaView, setMediaView: setMediaView, estate: estate, isBigScreen: isBigScreen } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    (0, $dTCkE.useEffect)(()=>{
        if (mediaView) {
            const htmlElement = document.querySelector("html");
            if (htmlElement) htmlElement.style.overflow = "hidden";
            return ()=>{
                if (htmlElement) htmlElement.style.overflow = "";
            };
        }
    }, []);
    //View options
    const imageView = estate?.images.length > 0;
    const movieView = estate?.links.filter((link)=>link?.category && link.category.toLowerCase().indexOf("film") > -1).length > 0;
    const constructPlan = estate?.images.filter((image)=>image?.category && image.category.toLowerCase() === "planl\xf6sning").length > 0;
    const insideView = estate?.links.filter((link)=>link?.category && link.category.toLowerCase() === "3d visning").length > 0;
    const heliView = estate?.links.filter((link)=>link?.category && link.category.toLowerCase() === "helikoptervy").length > 0;
    const mediaViewContainer = (0, $dTCkE.useRef)(null);
    const container = (0, $dTCkE.useMemo)(()=>mediaViewContainer, [
        mediaViewContainer
    ]);
    const isTouched = (0, $dkX7e.default)(container);
    let isScrollingDown = (0, $dTCkE.useMemo)(()=>isTouched, [
        isTouched
    ]);
    (0, $dTCkE.useEffect)(()=>{
        if (mediaViewContainer !== null) mediaViewContainer.current.scrollTop = 0;
    }, [
        mediaOption
    ]);
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $iAiYW.default), {
                displayMediaView: setMediaView,
                setMediaOption: setMediaOption
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                ref: mediaViewContainer,
                className: "top-0 lg:top-14 left-0 z-[1002] fixed bg-white pt-12 lg:pt-0 pb-[60px] lg:pb-[50px] w-screen h-screen lg:h-[calc(100vh-64px)] overflow-x-hidden overflow-y-scroll overscroll-contain",
                children: [
                    mediaOption === "imageView" && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex flex-col gap-2 m-auto max-w-7xl",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $9Ofhh.default), {
                            images: estate?.images
                        })
                    }),
                    mediaOption === "constructPlan" && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex flex-col gap-2 m-auto max-w-5xl",
                        children: estate?.images.filter((image)=>image.category.toLowerCase() === "planl\xf6sning").map((image, index)=>{
                            return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $ki08P.default), {
                                url: image?.path,
                                text: image?.text,
                                index: index,
                                alt: image?.text ? image?.text : "Planl\xf6sning " + estate?.addressInfo?.streetAddress
                            }, image?.path);
                        })
                    }),
                    mediaOption === "movieView" && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "relative -z-10 bg-white pt-12 md:pt-10 lg:pt-0 h-full overflow-auto mediaPlayer-container",
                        children: estate?.links?.filter((link)=>link.category.toLowerCase() === "film").map((link, index)=>{
                            return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "m-auto md:max-w-7xl mediaPlayer overscroll-none",
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                    fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                    children: /*#__PURE__*/ (0, $a9eYm.jsx)($15c1082192441aed$var$MediaPlayer, {
                                        videoUrl: link.links[0]
                                    })
                                })
                            }, index);
                        })
                    }),
                    mediaOption === "3DView" && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex flex-col m-auto max-w-7xl overscroll-none",
                        children: estate?.links?.filter((link)=>link.category.toLowerCase() === "3d visning").map((link, index)=>{
                            return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($15c1082192441aed$var$MediaView3D, {
                                    url: link.links[index]
                                }, index)
                            });
                        })
                    }),
                    mediaOption === "heliView" && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex flex-col items-center m-auto max-w-7xl overscroll-none",
                        children: estate?.links?.filter((link)=>link?.category && link.category.toLowerCase() === "helikoptervy").map((link, index)=>{
                            return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)($15c1082192441aed$var$MediaViewHeli, {
                                    url: link.links[index]
                                }, index)
                            });
                        })
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "top-1/2 left-1/2 fixed lg:shadow-[inset_-10px_0px_5px_-10px_#00000014] m-auto w-full max-w-7xl h-[100dvh] lg:h-[400px] -translate-x-1/2 -translate-y-1/2 overflow-x-hidden overflow-y-hidden pointer-events-none",
                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            className: `${isScrollingDown ? "-bottom-20" : "bottom-4"} transition-all duration-300 ease-in-out w-[98%] h-fit flex md:w-11/12 flex-row flex-nowrap lg:flex-col gap-[1px] fixed lg:absolute left-1/2 lg:left-auto -translate-x-1/2 lg:-translate-x-0 lg:right-[-204px] lg:hover:right-0 bg-grey100 lg:bg-blue700 rounded-md overflow-x-auto lg:overflow-hidden shadow-bs60 z-50 pointer-events-auto ${isBigScreen && "media-option-menu-side"}`,
                            children: [
                                imageView && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $b2sNg.default), {
                                    label: "Bilder",
                                    id: "imageView",
                                    icon: "/Images/Icons/objectPage/image-black.svg",
                                    mediaOption: mediaOption,
                                    setMediaOption: setMediaOption
                                }),
                                movieView && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $b2sNg.default), {
                                    label: "Filmvisning",
                                    id: "movieView",
                                    icon: "/Images/Icons/objectPage/movie-black.svg",
                                    mediaOption: mediaOption,
                                    setMediaOption: setMediaOption
                                }),
                                constructPlan && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $b2sNg.default), {
                                    label: "Planl\xf6sning",
                                    id: "constructPlan",
                                    icon: "/Images/Icons/objectPage/constructplan-black.svg",
                                    mediaOption: mediaOption,
                                    setMediaOption: setMediaOption
                                }),
                                insideView && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $b2sNg.default), {
                                    label: "3D-visning",
                                    id: "3DView",
                                    icon: "/Images/Icons/objectPage/3dView-black.svg",
                                    mediaOption: mediaOption,
                                    setMediaOption: setMediaOption
                                }),
                                heliView && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $b2sNg.default), {
                                    label: "Helikoptervy",
                                    id: "heliView",
                                    icon: "/Images/Icons/objectPage/360-black.svg",
                                    mediaOption: mediaOption,
                                    setMediaOption: setMediaOption
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var $15c1082192441aed$export$2e2bcd8739ae039 = $15c1082192441aed$var$MediaContainer;

});
parcelRegister("dkX7e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $983fc4a2727b924e$export$2e2bcd8739ae039; });

var $dTCkE = parcelRequire("dTCkE");
const $983fc4a2727b924e$var$useScrollListener = (targetRef)=>{
    const [isSwipingUp, setIsSwipingUp] = (0, $dTCkE.useState)(false);
    (0, $dTCkE.useEffect)(()=>{
        let startY = 0;
        let startX = 0;
        let endY = 0;
        let endX = 0;
        const handleTouchStart = (event)=>{
            startY = event.touches[0].clientY;
            startX = event.touches[0].clientX;
        };
        const handleTouchEnd = (event)=>{
            endY = event.changedTouches[0].clientY;
            endX = event.changedTouches[0].clientX;
            const verticalSwipe = Math.abs(endY - startY);
            const horizontalSwipe = Math.abs(endX - startX);
            setIsSwipingUp(verticalSwipe > horizontalSwipe && endY < startY);
        };
        const targetElement = targetRef.current;
        targetElement?.addEventListener("touchstart", handleTouchStart);
        targetElement?.addEventListener("touchend", handleTouchEnd);
        // Clean up the event listeners when the component unmounts
        return ()=>{
            targetElement?.removeEventListener("touchstart", handleTouchStart);
            targetElement?.removeEventListener("touchend", handleTouchEnd);
        };
    }, [
        targetRef.current
    ]);
    return isSwipingUp;
};
var $983fc4a2727b924e$export$2e2bcd8739ae039 = $983fc4a2727b924e$var$useScrollListener;

});

parcelRegister("ki08P", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4d1ce10c386341f$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $b4d1ce10c386341f$var$MediaViewImage = ({ url: url, alt: alt, text: text, index: index })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "image-item w-full m-auto h-auto flex flex-col items-center",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("picture", {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                    className: "object-contain m-auto h-auto w-auto max-h-sm md:max-h-md lg:max-h-[95vh] min-h-[260px]",
                    src: url,
                    alt: alt || "",
                    loading: index > 3 ? "lazy" : "eager",
                    width: 1440,
                    height: 960
                })
            }),
            text && /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                className: "py-2",
                children: text
            })
        ]
    });
};
var $b4d1ce10c386341f$export$2e2bcd8739ae039 = $b4d1ce10c386341f$var$MediaViewImage;

});

parcelRegister("iAiYW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a43c16b0ae499d58$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $cUbQm = parcelRequire("cUbQm");
const $a43c16b0ae499d58$var$MediaViewHeader = ({ displayMediaView: displayMediaView, setMediaOption: setMediaOption })=>{
    function backMediaView() {
        displayMediaView(false);
        setMediaOption("imageView");
        var url = window.location.href.split("#")[0];
        const newUrl = url;
        window.history.replaceState(null, null, newUrl);
    }
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "top-0 left-0 z-[1003] fixed bg-white w-screen h-12 lg:h-16",
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "relative flex items-center m-auto px-4 w-full max-w-7xl h-full",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
                    className: "flex lg:flex-row flex-col items-center gap-0 lg:gap-3 mb-1- lg:mb-0",
                    onClick: ()=>{
                        backMediaView();
                    },
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                            className: "w-[1.3rem] lg:w-6 h-auto transform rotate-180",
                            src: "/Images/Icons/Arrows/arrow-right-blue700.svg",
                            alt: "Ikon pil"
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: "font-icb text-blue700 text-tiny xl:text-base leading-6",
                            children: (0, $cUbQm.Common).Back
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                    className: "top-1/2 left-1/2 absolute w-auto h-7 -translate-x-1/2 -translate-y-1/2",
                    loading: "lazy",
                    src: "/Images/logotypes/logo.svg",
                    alt: "L\xe4nsf\xf6rs\xe4rkringar Fastighetsf\xf6rmedling logotyp",
                    width: 164,
                    height: 28
                })
            ]
        })
    });
};
var $a43c16b0ae499d58$export$2e2bcd8739ae039 = $a43c16b0ae499d58$var$MediaViewHeader;

});

parcelRegister("9Ofhh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d8756d412223d09c$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $ki08P = parcelRequire("ki08P");
const $d8756d412223d09c$var$ImageView = ({ images: images })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
        children: images && images?.filter((image)=>image?.category.toLowerCase() !== "planl\xf6sning").map((image, index)=>{
            return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $ki08P.default), {
                url: image?.path,
                alt: image.text ? image.text : "Objektbild",
                text: image?.text ? image?.text : "",
                index: index
            }, image?.path);
        })
    });
};
var $d8756d412223d09c$export$2e2bcd8739ae039 = $d8756d412223d09c$var$ImageView;

});

parcelRegister("b2sNg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a54fc847a253832a$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");
const $a54fc847a253832a$var$MediaViewOption = ({ label: label, id: id, icon: icon, mediaOption: mediaOption, setMediaOption: setMediaOption })=>{
    const { isBigScreen: isBigScreen } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const active = id === mediaOption ? true : false;
    function setMediaOptionView(id) {
        setMediaOption(id);
        var url = window.location.href.split("#")[0];
        const newUrl = url + "#" + id;
        window.history.replaceState(null, null, newUrl);
    }
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("button", {
        onClick: ()=>setMediaOptionView(id),
        className: `min-w-[120px] flex !basis-full flex-col lg:flex-row justify-center items-center gap-1 lg:gap-3 py-2 px-5 lg:px-8 transition ease duration-150 ${active ? "font-icb bg-white lg:bg-white text-blue700 shadow-[0_0_10px_0_#c9c9c9] z-10 lg:shadow-none" : "font-ic bg-grey10 lg:bg-blue700 text-grey300 lg:text-white"} lg:hover:bg-white lg:hover:text-blue700 lg:border-white lg:border-2 lg:rounded-md ${isBigScreen ? "media-option-hover" : ""}`,
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                className: `${active ? "filter-blue" : isBigScreen ? "filter-white" : "filter-dark-grey"} w-5`,
                src: icon,
                alt: `Ikon ${label}`
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                className: "whitespace-nowrap text-xs lg:text-base",
                children: label
            })
        ]
    });
};
var $a54fc847a253832a$export$2e2bcd8739ae039 = $a54fc847a253832a$var$MediaViewOption;

});

parcelRegister("5W42d", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("2sF91")).then(()=>parcelRequire("lSa1g"));

});

parcelRegister("lIzqO", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("dVMNd")).then(()=>parcelRequire("ePCAh"));

});

parcelRegister("fR3P5", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("crcNt")).then(()=>parcelRequire("k675D"));

});


parcelRegister("lGNl1", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("b9CEc")).then(()=>parcelRequire("aOn2A"));

});


parcelRegister("l2vbS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5b29d82e0a2b3e50$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $5b29d82e0a2b3e50$export$2e2bcd8739ae039({ itemsCount: itemsCount = 15 }) {
    const skeletonItems = Array.from({
        length: itemsCount
    }).map((_, index)=>/*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: `skeleton-item ${index % 4 === 3 ? "bg-white" : "bg-grey50"} ${index % 3 === 2 ? "w-4/5" : "w-full"}
      h-4 bg-grey50 rounded-md`
        }, index));
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "grid grid-cols-1 gap-3 my-8 lg:my-16 xl:my-20 xl:mb-16 max-w-[740px] mx-auto animate-pulse",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "h-12 mb-4 lg:mt-1 lg:mb-8 w-4/5 mx-auto bg-grey50 animate-pulse rounded-md"
            }),
            skeletonItems
        ]
    });
}

});

parcelRegister("kj1UN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $62db5df749db0f69$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $62db5df749db0f69$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "mx-auto max-w-7xl my-6 lg:my-16 px-3 lg:px-4 xxl:px-10",
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "gap-4 flex-col mdplus:flex-row xxl:gap-4 flex",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: "rounded-md w-full lg:w-1/2 h-[517px] lg:h-[368px] mdplus:h-[21rem] xxl:h-[23rem] bg-grey50 animate-pulse"
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    id: "map",
                    className: "rounded-md w-full lg:w-1/2 h-[320px] lg:h-[23rem] bg-grey50 animate-pulse"
                })
            ]
        })
    });
}

});

parcelRegister("eUjUM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $697a39c67043d35d$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $697a39c67043d35d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "grid gap-1 lg:gap-3 grid-cols-4 my-6 lg:my-16 md:grid-cols-6 m-auto px-0 lg:px-4 xxl:px-10",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative col-span-full md:col-span-3 h-48 md:h-56 lg:h-72 xxl:h-88 bg-grey50 animate-pulse"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative col-span-full md:col-span-3 h-48 md:h-56 lg:h-72 xxl:h-88 bg-grey50 animate-pulse hidden lg:block"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse hidden lg:block"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse lg:hidden"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative col-span-2 h-30 md:h-36 lg:h-56 xxl:h-66 bg-grey50 animate-pulse hidden lg:block"
            })
        ]
    });
}

});

parcelRegister("c9YBN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87e90e689d277be7$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $87e90e689d277be7$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex gap-3 justify-center m-auto z-[9] py-4 static top-auto left-auto animate-pulse",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[200px] py-3 px-3 rounded-md bg-blue700 h-12"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[200px] py-3 px-3 rounded-md bg-blue700 h-12"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[200px] py-3 px-3 rounded-md bg-blue700 h-12"
            })
        ]
    });
}

});

parcelRegister("eS5ey", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9dddbe0db30a553b$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $9dddbe0db30a553b$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "fixed bottom-0 left-0 w-full z-[1001]",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "h-[47px] bg-blue700 w-full rounded-t-[25px] py-3 px-3"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "h-[63px] bg-white "
            })
        ]
    });
}

});

parcelRegister("lno0h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $67a1ff1ee05bd9ba$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $67a1ff1ee05bd9ba$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "px-3 mx-auto max-w-7xl xl:my-10 xxl:my-16 lg:px-4 xxl:px-10 animate-pulse",
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: "bg-grey50 w-full rounded-md h-[484px] lg:h-[388px]"
        })
    });
}

});

parcelRegister("84aXW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3daae0cdf11d0827$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $3daae0cdf11d0827$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "mb-6 lg:mb-16 lg:mt-8 max-w-7xl mx-auto px-3 lg:px-4 xxl:px-10 overflow-hidden",
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: "bg-grey50 animate-pulse rounded-md h-[585px] md:h-[126px] lg:h-[175px]"
        })
    });
}

});

parcelRegister("7IEX2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $672f06e07ce1dd1c$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $672f06e07ce1dd1c$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        id: "widget",
        className: "max-w-7xl mx-auto my-6 lg:mt-16 lg:mb-8 px-3 lg:px-4 xxl:px-10 overflow-hidden",
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: "rounded-md shadow-bs40 animate-pulse h-[2026px] bg-grey50 md:h-[1954px] lg:h-[1049px]"
        })
    });
}

});

parcelRegister("7ky0J", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $823970f160bce595$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $823970f160bce595$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "my-6 lg:my-16 m-auto px-0 lg:px-4 xxl:px-10 ",
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: "aspect-video",
            children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "relative h-full bg-grey50 animate-pulse "
            })
        })
    });
}

});

parcelRegister("9xVId", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e6480e38d53f8519$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $dbFUM = parcelRequire("dbFUM");

var $fEaOX = parcelRequire("fEaOX");

var $kmjKG = parcelRequire("kmjKG");

var $kqTTL = parcelRequire("kqTTL");

const $e6480e38d53f8519$var$ObjectViewing = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("e23hO")));
const $e6480e38d53f8519$var$ObjectSidebar = ()=>{
    const { isBigScreen: isBigScreen } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("aside", {
        id: "overview",
        className: "font-ic relative lg:w-full z-10 lg:flex lg:justify-between lg:flex-col lg:bg-blue100 object-sidebar lg:overflow-y-auto lg:h-[calc(100vh-64px)] lg:sticky lg:top-[64px] lg:right-0",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "px-3 lg:px-0 ",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dbFUM.default), {})
                    }),
                    isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "lg:bg-blue100",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)($e6480e38d53f8519$var$ObjectViewing, {})
                        })
                    })
                ]
            }),
            isBigScreen === false && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $fEaOX.default), {}),
            /*#__PURE__*/ (0, $a9eYm.jsx)((0, $kmjKG.default), {})
        ]
    });
};
var $e6480e38d53f8519$export$2e2bcd8739ae039 = $e6480e38d53f8519$var$ObjectSidebar;

});
parcelRegister("dbFUM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18d8025159d4a175$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $N2wHE = parcelRequire("N2wHE");
parcelRequire("lLUSR");

var $cUbQm = parcelRequire("cUbQm");

var $eN4GS = parcelRequire("eN4GS");

var $jqJAi = parcelRequire("jqJAi");

var $1LCXV = parcelRequire("1LCXV");

var $g9Qwt = parcelRequire("g9Qwt");

var $72oDM = parcelRequire("72oDM");

var $gVY68 = parcelRequire("gVY68");

var $336qv = parcelRequire("336qv");

var $j5tJf = parcelRequire("j5tJf");

var $03VBy = parcelRequire("03VBy");

const $18d8025159d4a175$var$FinalPriceWatchForm = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("dZcix")));
function $18d8025159d4a175$export$2e2bcd8739ae039() {
    const [historyModal, setHistoryModal] = (0, $dTCkE.useState)(false);
    const [showHideFinalPrice, setShowHideFinalPrice] = (0, $dTCkE.useState)(false);
    const { objectId: objectId, estate: estate, isBigScreen: isBigScreen } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const activeBids = estate?.bids && estate?.bids.length > 0 ? estate?.bids.filter((bid)=>bid.cancelled === false && bid.status === "Deltar") : null;
    (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE))).locale("sv");
    return /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: `${estate?.bidSetting == 3 && estate?.bids && estate?.status?.id !== (0, $cUbQm.StatusId).Sold ? "lg:p-4 lg:pb-1" : "lg:px-4 lg:py-6"} flex flex-col my-4 lg:my-0 xxl:px-6 font-ic lg:bg-blue700 lg:text-white`,
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "flex justify-between items-start",
                        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                            children: [
                                estate && estate?.status.id != (0, $cUbQm.StatusId).Sold && (estate?.bidSetting == 1 || estate?.bidSetting == 2 || estate?.bidSetting == 3) ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $j5tJf.default), {}) : null,
                                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                    className: "flex gap-4 mb-2 lg:mb-3",
                                    children: [
                                        (estate?.bidSetting == 2 || estate?.bidSetting == 3) && estate?.status.id != (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                estate?.bids?.length ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eN4GS.default), {
                                                    text: `H\xf6gsta bud`
                                                }) : null,
                                                !estate?.bids?.length && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eN4GS.default), {
                                                    text: `${estate?.priceInfo?.text ? estate?.priceInfo?.text.charAt(0).toUpperCase() + estate?.priceInfo?.text.slice(1) : "Utg\xe5ngspris"}`
                                                })
                                            ]
                                        }) : null,
                                        estate?.priceInfo?.priceMin && estate?.priceInfo?.priceMax && estate?.estateTypeAsString == (0, $cUbQm.EstateType).Project ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eN4GS.default), {
                                            text: `Pris`
                                        }) : null,
                                        estate?.estateTypeAsString != (0, $cUbQm.EstateType).Project && estate?.bidSetting != 2 && estate?.bidSetting != 3 && estate?.priceInfo?.startPrice != 0 && estate?.status.id != (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eN4GS.default), {
                                            text: `${estate?.priceInfo?.text ? estate?.priceInfo?.text.charAt(0).toUpperCase() + estate?.priceInfo?.text.slice(1) : "Utg\xe5ngspris"}`
                                        }) : null,
                                        estate?.status.id == (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $eN4GS.default), {
                                            text: `${estate?.priceInfo?.finalPrice ? "Slutpris" : "Utg\xe5ngspris"}`
                                        }) : null,
                                        estate?.status.id != (0, $cUbQm.StatusId).Sold && !estate?.isHeadStart && estate?.estateTypeAsString !== (0, $cUbQm.EstateType).Project && estate?.estateTypeAsString !== (0, $cUbQm.EstateType).Commercial ? /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                                            onClick: (e)=>{
                                                setShowHideFinalPrice(true);
                                            },
                                            children: /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                className: "text-base font-ic underline",
                                                children: "Bevaka slutpris"
                                            })
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, $a9eYm.jsxs)("h2", {
                                    className: "text-4xl lg:text-3xl xl:text-4xl font-lf text-blue700 lg:text-white leading-8 my-2",
                                    children: [
                                        (estate?.bidSetting == 2 || estate?.bidSetting == 3) && estate?.status.id != (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsxs)((0, $a9eYm.Fragment), {
                                            children: [
                                                estate?.bids && estate?.bids?.length > 0 && activeBids && activeBids[0] ? /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                                    children: [
                                                        activeBids[0]?.amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                                                        " ",
                                                        "kr"
                                                    ]
                                                }) : null,
                                                (!estate?.bids || estate?.bids?.length == 0) && estate?.priceInfo.startPrice ? /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                                    children: [
                                                        estate?.priceInfo.startPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                                                        " ",
                                                        "kr"
                                                    ]
                                                }) : null
                                            ]
                                        }) : null,
                                        estate?.bidSetting !== 2 && estate?.bidSetting !== 3 && estate?.status.id != (0, $cUbQm.StatusId).Sold && estate?.priceInfo?.startPrice != 0 && estate?.priceInfo?.startPrice != null ? /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                            children: [
                                                estate?.priceInfo.startPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                                                " ",
                                                "kr"
                                            ]
                                        }) : null,
                                        estate?.priceInfo?.priceMin && estate?.priceInfo?.priceMax && estate?.estateTypeAsString == (0, $cUbQm.EstateType).Project ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $72oDM.default), {}) : null,
                                        estate?.status.id == (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $gVY68.default), {}) : null,
                                        estate?.status.id != (0, $cUbQm.StatusId).Sold && !estate?.priceInfo?.priceMin && !estate?.priceInfo?.priceMax && (!estate?.priceInfo.startPrice || estate?.priceInfo.startPrice == 0) && estate?.bidSetting !== 3 && estate?.bidSetting !== 2 && /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                            className: "text-3xl lg:text-2xl xxl:text-3xl font-lf text-blue700 lg:text-white leading-8",
                                            children: "Pris ej angivet"
                                        })
                                    ]
                                }),
                                estate?.status.id == (0, $cUbQm.StatusId).Sold && estate?.movingIn && /*#__PURE__*/ (0, $a9eYm.jsxs)("p", {
                                    className: "my-0 mt-2 xxl:mt-4",
                                    children: [
                                        "S\xe5ld:",
                                        " ",
                                        (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(estate.movingIn, "DD-MM-YYYY").format("YYYY-MM-DD")
                                    ]
                                }),
                                estate?.priceInfo.startPrice != 0 && estate?.priceInfo.startPrice !== null && (estate?.bidSetting == 2 || estate?.bidSetting == 3) && estate?.bids[0] && estate?.status.id != (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $336qv.default), {}) : null
                            ]
                        })
                    }),
                    (estate?.bidSetting == 1 || estate?.bidSetting == 2 || estate?.bidSetting == 3) && estate?.status.id != (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $g9Qwt.default), {}) : null,
                    estate?.bidSetting === 3 && estate?.bids && estate?.status?.id !== (0, $cUbQm.StatusId).Sold ? /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "border-2 border-blue700 rounded-md my-4 lg:my-0",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
                                onClick: (e)=>{
                                    if (historyModal === false) setHistoryModal(true);
                                    else setHistoryModal(false);
                                },
                                className: "lg:text-white text-blue700 font-icb lg:mt-2 lg:mb-0 w-full items-center justify-center mx-auto bidding-history-btn",
                                children: estate?.bidSetting == 3 && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $jqJAi.default), {
                                    historyModal: historyModal
                                })
                            }),
                            historyModal && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $03VBy.default), {})
                        ]
                    }) : null
                ]
            }),
            estate?.econansReady && isBigScreen && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $1LCXV.default), {}),
            showHideFinalPrice && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($18d8025159d4a175$var$FinalPriceWatchForm, {
                    setShowHideModalFunction: setShowHideFinalPrice,
                    estateAddress: estate?.addressInfo?.streetAddress,
                    estateId: objectId,
                    customerId: estate?.customerId
                })
            })
        ]
    });
}

});
parcelRegister("eN4GS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $93b023882f70c20d$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $93b023882f70c20d$var$BaseTextInfo = ({ text: text })=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
        className: "text-base",
        children: text
    });
};
var $93b023882f70c20d$export$2e2bcd8739ae039 = $93b023882f70c20d$var$BaseTextInfo;

});

parcelRegister("jqJAi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a4a1fa1c2aef5e7e$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");
const $a4a1fa1c2aef5e7e$var$ShowHistory = ({ historyModal: historyModal })=>{
    const { isBigScreen: isBigScreen } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "items-center mx-auto flex justify-center my-3",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                alt: "Icon arrow",
                className: `${historyModal ? "" : "rotate-180"} w-3`,
                loading: "lazy",
                width: "12",
                height: "7",
                src: isBigScreen ? "/Images/Icons/Arrows/arrow-up-white.svg" : "/Images/Icons/Arrows/arrow-up-blue.svg"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                className: "text-center block mx-4",
                children: "Visa budhistorik"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                alt: "Icon arrow",
                loading: "lazy",
                width: "12",
                height: "7",
                className: `${historyModal ? "" : "rotate-180"} w-3`,
                src: isBigScreen ? "/Images/Icons/Arrows/arrow-up-white.svg" : "/Images/Icons/Arrows/arrow-up-blue.svg"
            })
        ]
    });
};
var $a4a1fa1c2aef5e7e$export$2e2bcd8739ae039 = $a4a1fa1c2aef5e7e$var$ShowHistory;

});

parcelRegister("1LCXV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6411b7742d76e07$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
const $a6411b7742d76e07$var$EconansBtn = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "lg:bg-blue100 hidden xl:block p-4 xxl:px-6 pt-6 lg:pt-4 xxl:pt-6 w-full",
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("button", {
            onClick: (e)=>{
                const element = document.getElementById("widget");
                const yOffset = -210;
                const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
                window.scrollTo({
                    top: y,
                    behavior: "smooth"
                });
            },
            className: "text-blue700 border-2 border-blue700 py-3 w-full text-center rounded-md font-icb hover-blue-border transform duration-200 block",
            children: "Ber\xe4kna din boendekostnad"
        })
    });
};
var $a6411b7742d76e07$export$2e2bcd8739ae039 = $a6411b7742d76e07$var$EconansBtn;

});

parcelRegister("g9Qwt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5abc23462350dd1$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");
const $a5abc23462350dd1$var$ReadAboutBidding = ()=>{
    const { isBigScreen: isBigScreen } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("a", {
        className: "inline-flex self-start items-center hover-move-arrow",
        href: "/budgivning",
        target: "_blank",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                className: "text-tiny text-black500 lg:text-white",
                children: "L\xe4s mer om budgivning"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                width: "16",
                height: "8",
                className: "viewing-icon arrow-move ml-2 w-4",
                src: isBigScreen ? "/Images/Icons/Arrows/arrow-right-white.svg" : "/Images/Icons/Arrows/arrow-right-blue700.svg",
                alt: "Arrow icon"
            })
        ]
    });
};
var $a5abc23462350dd1$export$2e2bcd8739ae039 = $a5abc23462350dd1$var$ReadAboutBidding;

});

parcelRegister("72oDM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18b9c1522dfe5255$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");
const $18b9c1522dfe5255$var$ProjectPrice = ()=>{
    const { estate: estate } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
        className: "text-3xl lg:text-2xl xxxl:text-2xl font-lf text-blue700 lg:text-white leading-8",
        dangerouslySetInnerHTML: {
            __html: estate?.priceInfo?.priceMin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " - " + estate?.priceInfo?.priceMax.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " kr"
        }
    });
};
var $18b9c1522dfe5255$export$2e2bcd8739ae039 = $18b9c1522dfe5255$var$ProjectPrice;

});

parcelRegister("gVY68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d86aedbe6594645b$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");
const $d86aedbe6594645b$var$SoldPrice = ()=>{
    const { estate: estate } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
        children: estate?.priceInfo?.finalPrice ? estate?.priceInfo?.finalPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " kr" : estate?.priceInfo?.startPrice ? estate?.priceInfo?.startPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " kr" : "Pris ej angivet"
    });
};
var $d86aedbe6594645b$export$2e2bcd8739ae039 = $d86aedbe6594645b$var$SoldPrice;

});

parcelRegister("336qv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $522ccd461fbd6afb$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");
const $522ccd461fbd6afb$var$StartingPrice = ()=>{
    const { estate: estate } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "flex flex-row gap-2 mb-2",
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
            className: "header-info-item text-lg",
            children: [
                "Utg\xe5ngspris:",
                " ",
                estate?.priceInfo.startPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                " ",
                "kr"
            ]
        })
    });
};
var $522ccd461fbd6afb$export$2e2bcd8739ae039 = $522ccd461fbd6afb$var$StartingPrice;

});

parcelRegister("j5tJf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a4d2f5f5cce0b2b$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $5J7FU = parcelRequire("5J7FU");
const $1a4d2f5f5cce0b2b$var$BiddingPing = ()=>{
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: "w-full mb-2",
        children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: "flex items-center mb-0",
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "flex h-2 w-2 relative mr-2",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: "animate-ping absolute inline-flex h-full w-full rounded-full bg-white lg:bg-white bg-opacity-75"
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: "relative inline-flex rounded-full h-2 w-2 bg-white lg:bg-white"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                    className: "text-tiny",
                    children: (0, $5J7FU.ForSaleStrings).Bidding
                })
            ]
        })
    });
};
var $1a4d2f5f5cce0b2b$export$2e2bcd8739ae039 = $1a4d2f5f5cce0b2b$var$BiddingPing;

});
parcelRegister("5J7FU", function(module, exports) {

$parcel$export(module.exports, "ForSaleStrings", function () { return $99df1cd5eac2d33b$export$bcfdb61b9eaf9a50; });
var $99df1cd5eac2d33b$export$bcfdb61b9eaf9a50;
(function(ForSaleStrings) {
    ForSaleStrings["NotFindingHeadling"] = "Hittar du inte vad du s\xf6ker?";
    ForSaleStrings["NotFindingText"] = "Oroa dig inte. Vi f\xe5r in nya bost\xe4der hela tiden. Kanske \xe4r din dr\xf6mbostad bara ett par dagar bort? Skapa en bevakning s\xe5 att du inte missar n\xe4r den dyker upp!";
    ForSaleStrings["FetchError"] = "Kunde inte h\xe4mta bost\xe4der just nu. F\xf6rs\xf6k igen om en liten stund.";
    ForSaleStrings["Estates"] = "Bost\xe4der";
    ForSaleStrings["SingleEstate"] = "Bostad";
    ForSaleStrings["NoResults"] = "Din s\xf6kning gav inga tr\xe4ffar";
    ForSaleStrings["Loading"] = "Laddar...";
    ForSaleStrings["Bidding"] = "Budgivning p\xe5g\xe5r";
    ForSaleStrings["BiddingShort"] = "Budgivning";
})($99df1cd5eac2d33b$export$bcfdb61b9eaf9a50 || ($99df1cd5eac2d33b$export$bcfdb61b9eaf9a50 = {}));

});


parcelRegister("03VBy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4a49e6144335c58f$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $N2wHE = parcelRequire("N2wHE");
const $4a49e6144335c58f$var$BiddingHistory = ()=>{
    const { estate: estate } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    let listOfStoppedBidders = new Array();
    let newDate = new Date();
    const yesterday = new Date(new Date().setDate(new Date().getDate() - 1));
    const date = newDate.getDate();
    const month = newDate.getMonth() + 1;
    const yesterdayDate = yesterday.getDate();
    const yesterdayMonth = yesterday.getMonth() + 1;
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "lg:bg-blue700 px-6 lg:px-0 pb-4 lg:text-white",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("hr", {
                className: "border-t-1 border-white lg:hidden"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                className: "justify-between flex mb-1 mdplus:text-tiny xl:text-base font-icb",
                children: [
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "w-1/3 lg:w-2/5 ",
                        children: "Bud"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "w-1/5 lg:w-1/4",
                        children: "Datum"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                        className: "w-1/5",
                        children: "Tid"
                    }),
                    /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                        className: "w-1/5 text-right",
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: "",
                            children: "Budgivare"
                        })
                    })
                ]
            }),
            estate?.bids && estate?.bids !== undefined && estate?.bids.map((bid)=>(bid?.status == "Deltar" || bid?.status == "Stannat i budgivning") && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                    className: "justify-between flex mb-2 mdplus:text-tiny xxl:text-base items-center",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                            className: `${bid?.cancelled ? "line-through" : ""} w-1/3 lg:w-2/5`,
                            children: [
                                bid?.amount.toLocaleString("SV-se"),
                                " kr",
                                " ",
                                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                    className: "text-tiny",
                                    children: bid?.status == "Stannat i budgivning" && listOfStoppedBidders.indexOf(bid?.alias) == -1 ? "*" : ""
                                })
                            ]
                        }),
                        bid?.status == "Stannat i budgivning" && /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: "hidden",
                            children: listOfStoppedBidders.push(bid?.alias)
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: `${bid?.cancelled ? "line-through" : ""} w-1/5 lg:w-1/4`,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(bid?.dateAndTime).format("DD") == yesterdayDate.toString() && (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(bid?.dateAndTime).format("M") == yesterdayMonth.toString() ? "Ig\xe5r" : (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(bid?.dateAndTime).format("DD") == date.toString() && (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(bid?.dateAndTime).format("M") == month.toString() ? "Idag" : (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(bid?.dateAndTime).format("D") + "/" + (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(bid?.dateAndTime).format("M")
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                            className: `${bid?.cancelled ? "line-through" : ""} w-1/5`,
                            children: (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE)))(bid?.dateAndTime).format("HH:mm")
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                            className: "w-1/5 text-right",
                            children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: "xl:w-6 xl:h-6 w-6 h-6 lg:w-5 lg:h-5 font-icb lg:font-ic text-xs xl:text-tiny lg:bg-white border-2 border-blue700 lg:border-0 text-blue700 rounded-full ml-auto text-center",
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                    className: "align-middle",
                                    children: bid?.alias
                                })
                            })
                        })
                    ]
                }, bid?.dateAndTime)),
            listOfStoppedBidders.length > 0 && /*#__PURE__*/ (0, $a9eYm.jsx)("p", {
                className: "mt-4 mb-0 text-tiny",
                children: "* Stannat i budgivning"
            })
        ]
    });
};
var $4a49e6144335c58f$export$2e2bcd8739ae039 = $4a49e6144335c58f$var$BiddingHistory;

});

parcelRegister("dZcix", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("74Z0M")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hbeiW")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("4G055")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("7KCxG")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("b8wHJ"))
]).then(()=>parcelRequire("hDGTz"));

});


parcelRegister("kmjKG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c61004e93a2c7622$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $9Hiep = parcelRequire("9Hiep");

var $kqTTL = parcelRequire("kqTTL");
function $c61004e93a2c7622$export$2e2bcd8739ae039() {
    const { estate: estate } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "mb-4 lg:mb-0 bg-blue100 px-3 lg:px-4 pb-6 pt-4 lg:py-0 xxl:px-6 min-h-[223px] lg:min-h-[200px]",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "md:flex md:gap-4 lg:gap-0 lg:block",
                children: estate?.brokers && estate?.brokers !== undefined && estate?.brokers.map((brokerItem, index)=>/*#__PURE__*/ (0, $a9eYm.jsx)((0, $9Hiep.ObjectBrokerItem), {
                        broker: brokerItem,
                        indexNo: index
                    }, brokerItem?.id))
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "my-4 mb-0 lg:mb-6 lg:mt-6 font-icb w-full",
                children: estate?.officeInfo?.url && estate?.officeInfo?.name && /*#__PURE__*/ (0, $a9eYm.jsxs)("a", {
                    className: "flex justify-center items-center hover-move-arrow text-blue700",
                    href: `https://${estate?.officeInfo?.url?.replace("https://", "")}`,
                    target: "_blank",
                    children: [
                        /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                            children: [
                                "Till kontoret ",
                                estate?.officeInfo?.name
                            ]
                        }),
                        /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                            width: "20",
                            height: "12",
                            className: "w-5 ml-3 arrow-move",
                            src: "/Images/Icons/Arrows/arrow-right-blue700.svg",
                            loading: "lazy",
                            alt: "Arrow right icon"
                        })
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("9Hiep", function(module, exports) {

$parcel$export(module.exports, "ObjectBrokerItem", function () { return $c5fb01eebd955db7$export$5977417ceaf5cb59; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $l8eky = parcelRequire("l8eky");

var $5jxwZ = parcelRequire("5jxwZ");
const $c5fb01eebd955db7$export$5977417ceaf5cb59 = ({ broker: broker, indexNo: indexNo })=>{
    const [isActive, setActive] = (0, $dTCkE.useState)(false);
    const [x, setX] = (0, $dTCkE.useState)("");
    const [y, setY] = (0, $dTCkE.useState)("");
    const [clickEvent, setClickEvent] = (0, $dTCkE.useState)(false);
    const handleClickLink = (x, y)=>(event)=>{
            contactRequest(x, y);
        };
    const contactRequest = (x, y)=>{
        setX(x);
        setY(y);
        setClickEvent(true);
    };
    const handleClick = (item)=>{
        setActive(!isActive);
    };
    return /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {
        children: broker?.name != null && /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
            className: `${isActive ? "active-broker" : ""} flex justify-between flex-wrap items-center bg-white my-4 rounded-md md:w-1/2 lg:w-full`,
            children: [
                /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                    className: `${isActive ? "max-h-[138px]" : ""} contact-container h-full pr-3 overflow-hidden self-start`,
                    children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                        className: "flex overflow-hidden items-stretch h-full",
                        children: [
                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                className: `self-center broker-content w-full flex-shrink-0 h-full`,
                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                    className: "flex overflow-hidden items-center align-center py-0 flex-wrap h-full",
                                    children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                        onClick: (e)=>{
                                            handleClick(undefined);
                                        },
                                        className: `flex justify-between flex-shrink-0 w-full cursor-pointer h-full items-center`,
                                        children: [
                                            broker?.thumbnail && /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                                width: "89",
                                                height: "125",
                                                loading: `${indexNo === 0 ? "eager" : "lazy"}`,
                                                src: broker?.thumbnail,
                                                alt: broker?.name,
                                                className: `block overflow-hidden bg-cover w-24 h-full filter rounded-bl-md rounded-tl-md object-cover ${(0, $l8eky.officeBrokerGrayScale)(broker?.officeName) ? "grayscale" : ""}`
                                            }),
                                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                                className: "w-4/5 pb-1 pt-2",
                                                children: /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                                    className: "pl-3 flex items-center justify-between",
                                                    children: [
                                                        /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                                            className: "",
                                                            children: [
                                                                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                                    className: "text-grey300 font-ic text-tiny block",
                                                                    children: indexNo === 0 ? "Ansvarig m\xe4klare" : "Extra kontaktperson"
                                                                }),
                                                                /*#__PURE__*/ (0, $a9eYm.jsx)("h5", {
                                                                    className: "font-icb text-lg mdplus:text-base xl:text-lg",
                                                                    children: broker?.name
                                                                }),
                                                                /*#__PURE__*/ (0, $a9eYm.jsx)("span", {
                                                                    className: "text-grey300 font-ic text-tiny inline-block leading-4",
                                                                    children: broker?.title
                                                                }),
                                                                broker?.extraTitle && /*#__PURE__*/ (0, $a9eYm.jsxs)("span", {
                                                                    className: "text-grey300 font-ic text-tiny inline-block leading-4",
                                                                    children: [
                                                                        "/",
                                                                        broker?.extraTitle
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                                            width: "24",
                                                            height: "12",
                                                            className: "ml-2 w-6",
                                                            src: "/Images/Icons/Arrows/arrow-right-blue700.svg",
                                                            alt: "Arrow right icon",
                                                            loading: `${indexNo === 0 ? "eager" : "lazy"}`
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                className: `${isActive ? "translate-x-1/1-" : ""} flex-row flex items-center rounded-md py-2 pl-3 bg-white w-full justify-between flex-shrink-0 transform transition duration-200`,
                                children: [
                                    /*#__PURE__*/ (0, $a9eYm.jsx)("img", {
                                        width: "24",
                                        height: "12",
                                        className: "cursor-pointer w-6 contact-card-back-img transform rotate-180",
                                        src: "/Images/Icons/Arrows/arrow-right-blue700.svg",
                                        loading: "lazy",
                                        alt: "Arrow left icon",
                                        onClick: (e)=>{
                                            handleClick(broker?.name);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
                                        className: "w-full ml-4",
                                        children: [
                                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                                className: "cursor-pointer text-center rounded-md hover-blue-border transition duration-200 border-2 font-icb border-blue700 text-blue700 block w-full mb-2",
                                                id: "contact-phone",
                                                children: /*#__PURE__*/ (0, $a9eYm.jsx)("a", {
                                                    onClick: handleClickLink("M\xe4klare", "Telefon"),
                                                    className: "p-2 block",
                                                    href: `tel:${broker?.phone?.trim()}`,
                                                    children: broker?.phone
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                                                className: "cursor-pointer hover-darken-blue text-center mt-2 rounded-md bg-blue700 text-white block w-full font-icb",
                                                id: "contact-email",
                                                children: /*#__PURE__*/ (0, $a9eYm.jsxs)("a", {
                                                    onClick: handleClickLink("M\xe4klare", "Mail"),
                                                    className: "p-2 block",
                                                    href: `mailto:${broker?.email}`,
                                                    children: [
                                                        "Maila ",
                                                        broker?.name
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                clickEvent && x && y && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.HelmetProvider), {
                    children: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $5jxwZ.Helmet), {
                        children: /*#__PURE__*/ (0, $a9eYm.jsx)("script", {
                            children: `
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'kontakt',
                    'eventInfo': {
                      'kontakt': '${x}',
                      'kontakttyp': '${y}'
                  }
                });
                `
                        })
                    })
                })
            ]
        })
    });
};

});


parcelRegister("e23hO", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("dOc0a")).then(()=>parcelRequire("1cE51"));

});


parcelRegister("8fUOS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8835ebea516c76a4$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");
const $8835ebea516c76a4$export$b333fb675799e6b9 = ()=>{
    const { estate: data } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    return /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
        className: `${data?.econansReady ? "lg:px-4 xxl:px-10 my-6 lg:my-16" : ""}`,
        children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
            className: `${data?.econansReady ? "bg-white shadow-bs40 rounded-md overflow-hidden" : ""} `,
            children: /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "overflow-hidden",
                id: "miniwidget"
            })
        })
    });
};
var $8835ebea516c76a4$export$2e2bcd8739ae039 = $8835ebea516c76a4$export$b333fb675799e6b9;

});

parcelRegister("aZDKU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1f3e804c4ba21b3$export$2e2bcd8739ae039; });

var $4cyLg = parcelRequire("4cyLg");

var $1HGFx = parcelRequire("1HGFx");
const $c1f3e804c4ba21b3$var$useEstate = (estateId, intake)=>{
    //! estate is static key, id needs to be dynamic, will get estateId as id from url later. getEstate need estateId later
    return (0, $4cyLg.useQuery)([
        "estate",
        estateId
    ], ()=>(0, $1HGFx.EstatesService).estatesGetEstate(estateId, intake).then((response)=>response), {
        enabled: !!estateId,
        retry: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false,
        cacheTime: 300000,
        staleTime: 300000
    });
};
var $c1f3e804c4ba21b3$export$2e2bcd8739ae039 = $c1f3e804c4ba21b3$var$useEstate;

});

parcelRegister("dIKI1", function(module, exports) {

$parcel$export(module.exports, "useInView", function () { return $9fd39dd7df352507$export$2f62ee6831462844; });

var $dTCkE = parcelRequire("dTCkE");
"use client";
var $9fd39dd7df352507$var$__defProp = Object.defineProperty;
var $9fd39dd7df352507$var$__defNormalProp = (obj, key, value)=>key in obj ? $9fd39dd7df352507$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $9fd39dd7df352507$var$__publicField = (obj, key, value)=>{
    $9fd39dd7df352507$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/observe.ts
var $9fd39dd7df352507$var$observerMap = /* @__PURE__ */ new Map();
var $9fd39dd7df352507$var$RootIds = /* @__PURE__ */ new WeakMap();
var $9fd39dd7df352507$var$rootId = 0;
var $9fd39dd7df352507$var$unsupportedValue = void 0;
function $9fd39dd7df352507$export$2ef3a60ee1f37bec(inView) {
    $9fd39dd7df352507$var$unsupportedValue = inView;
}
function $9fd39dd7df352507$var$getRootId(root) {
    if (!root) return "0";
    if ($9fd39dd7df352507$var$RootIds.has(root)) return $9fd39dd7df352507$var$RootIds.get(root);
    $9fd39dd7df352507$var$rootId += 1;
    $9fd39dd7df352507$var$RootIds.set(root, $9fd39dd7df352507$var$rootId.toString());
    return $9fd39dd7df352507$var$RootIds.get(root);
}
function $9fd39dd7df352507$var$optionsToId(options) {
    return Object.keys(options).sort().filter((key)=>options[key] !== void 0).map((key)=>{
        return `${key}_${key === "root" ? $9fd39dd7df352507$var$getRootId(options.root) : options[key]}`;
    }).toString();
}
function $9fd39dd7df352507$var$createObserver(options) {
    const id = $9fd39dd7df352507$var$optionsToId(options);
    let instance = $9fd39dd7df352507$var$observerMap.get(id);
    if (!instance) {
        const elements = /* @__PURE__ */ new Map();
        let thresholds;
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                var _a;
                const inView = entry.isIntersecting && thresholds.some((threshold)=>entry.intersectionRatio >= threshold);
                if (options.trackVisibility && typeof entry.isVisible === "undefined") entry.isVisible = inView;
                (_a = elements.get(entry.target)) == null || _a.forEach((callback)=>{
                    callback(inView, entry);
                });
            });
        }, options);
        thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [
            options.threshold || 0
        ]);
        instance = {
            id: id,
            observer: observer,
            elements: elements
        };
        $9fd39dd7df352507$var$observerMap.set(id, instance);
    }
    return instance;
}
function $9fd39dd7df352507$export$d1203567a167490e(element, callback, options = {}, fallbackInView = $9fd39dd7df352507$var$unsupportedValue) {
    if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
        const bounds = element.getBoundingClientRect();
        callback(fallbackInView, {
            isIntersecting: fallbackInView,
            target: element,
            intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
            time: 0,
            boundingClientRect: bounds,
            intersectionRect: bounds,
            rootBounds: bounds
        });
        return ()=>{};
    }
    const { id: id, observer: observer, elements: elements } = $9fd39dd7df352507$var$createObserver(options);
    const callbacks = elements.get(element) || [];
    if (!elements.has(element)) elements.set(element, callbacks);
    callbacks.push(callback);
    observer.observe(element);
    return function unobserve() {
        callbacks.splice(callbacks.indexOf(callback), 1);
        if (callbacks.length === 0) {
            elements.delete(element);
            observer.unobserve(element);
        }
        if (elements.size === 0) {
            observer.disconnect();
            $9fd39dd7df352507$var$observerMap.delete(id);
        }
    };
}
// src/InView.tsx
function $9fd39dd7df352507$var$isPlainChildren(props) {
    return typeof props.children !== "function";
}
var $9fd39dd7df352507$export$a62107ca74432f44 = class extends $dTCkE.Component {
    constructor(props){
        super(props);
        $9fd39dd7df352507$var$__publicField(this, "node", null);
        $9fd39dd7df352507$var$__publicField(this, "_unobserveCb", null);
        $9fd39dd7df352507$var$__publicField(this, "handleNode", (node)=>{
            if (this.node) {
                this.unobserve();
                if (!node && !this.props.triggerOnce && !this.props.skip) this.setState({
                    inView: !!this.props.initialInView,
                    entry: void 0
                });
            }
            this.node = node ? node : null;
            this.observeNode();
        });
        $9fd39dd7df352507$var$__publicField(this, "handleChange", (inView, entry)=>{
            if (inView && this.props.triggerOnce) this.unobserve();
            if (!$9fd39dd7df352507$var$isPlainChildren(this.props)) this.setState({
                inView: inView,
                entry: entry
            });
            if (this.props.onChange) this.props.onChange(inView, entry);
        });
        this.state = {
            inView: !!props.initialInView,
            entry: void 0
        };
    }
    componentDidMount() {
        this.unobserve();
        this.observeNode();
    }
    componentDidUpdate(prevProps) {
        if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
            this.unobserve();
            this.observeNode();
        }
    }
    componentWillUnmount() {
        this.unobserve();
    }
    observeNode() {
        if (!this.node || this.props.skip) return;
        const { threshold: threshold, root: root, rootMargin: rootMargin, trackVisibility: trackVisibility, delay: delay, fallbackInView: fallbackInView } = this.props;
        this._unobserveCb = $9fd39dd7df352507$export$d1203567a167490e(this.node, this.handleChange, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
    }
    unobserve() {
        if (this._unobserveCb) {
            this._unobserveCb();
            this._unobserveCb = null;
        }
    }
    render() {
        const { children: children } = this.props;
        if (typeof children === "function") {
            const { inView: inView, entry: entry } = this.state;
            return children({
                inView: inView,
                entry: entry,
                ref: this.handleNode
            });
        }
        const { as: as, triggerOnce: triggerOnce, threshold: threshold, root: root, rootMargin: rootMargin, onChange: onChange, skip: skip, trackVisibility: trackVisibility, delay: delay, initialInView: initialInView, fallbackInView: fallbackInView, ...props } = this.props;
        return $dTCkE.createElement(as || "div", {
            ref: this.handleNode,
            ...props
        }, children);
    }
};
function $9fd39dd7df352507$export$2f62ee6831462844({ threshold: threshold, delay: delay, trackVisibility: trackVisibility, rootMargin: rootMargin, root: root, triggerOnce: triggerOnce, skip: skip, initialInView: initialInView, fallbackInView: fallbackInView, onChange: onChange } = {}) {
    var _a;
    const [ref, setRef] = $dTCkE.useState(null);
    const callback = $dTCkE.useRef();
    const [state, setState] = $dTCkE.useState({
        inView: !!initialInView,
        entry: void 0
    });
    callback.current = onChange;
    $dTCkE.useEffect(()=>{
        if (skip || !ref) return;
        let unobserve;
        unobserve = $9fd39dd7df352507$export$d1203567a167490e(ref, (inView, entry)=>{
            setState({
                inView: inView,
                entry: entry
            });
            if (callback.current) callback.current(inView, entry);
            if (entry.isIntersecting && triggerOnce && unobserve) {
                unobserve();
                unobserve = void 0;
            }
        }, {
            root: root,
            rootMargin: rootMargin,
            threshold: threshold,
            trackVisibility: // @ts-ignore
            trackVisibility,
            delay: // @ts-ignore
            delay
        }, fallbackInView);
        return ()=>{
            if (unobserve) unobserve();
        };
    }, // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        // If the threshold is an array, convert it to a string, so it won't change between renders.
        Array.isArray(threshold) ? threshold.toString() : threshold,
        ref,
        root,
        rootMargin,
        triggerOnce,
        skip,
        trackVisibility,
        fallbackInView,
        delay
    ]);
    const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
    const previousEntryTarget = $dTCkE.useRef();
    if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
        previousEntryTarget.current = entryTarget;
        setState({
            inView: !!initialInView,
            entry: void 0
        });
    }
    const result = [
        setRef,
        state.inView,
        state.entry
    ];
    result.ref = result[0];
    result.inView = result[1];
    result.entry = result[2];
    return result;
}

});

parcelRegister("kcxrH", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44bd6f2f96854fde$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");
function $44bd6f2f96854fde$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        className: "flex flex-wrap gap-3 gap-y-2 lg:px-0 lg:justify-center m-auto z-[9] static top-auto left-auto animate-pulse my-8 xl:mb-16 max-w-[740px] mx-auto",
        children: [
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"
            }),
            /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "flex gap-3 justify-center min-w-[70px] py-3 px-3 rounded-md bg-grey100 h-2"
            })
        ]
    });
}

});

parcelRegister("lQsIr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b2ff442787335c5$export$2e2bcd8739ae039; });

var $a9eYm = parcelRequire("a9eYm");

var $dTCkE = parcelRequire("dTCkE");

var $kqTTL = parcelRequire("kqTTL");

var $N2wHE = parcelRequire("N2wHE");
parcelRequire("lLUSR");

var $cUbQm = parcelRequire("cUbQm");

var $hPa9t = parcelRequire("hPa9t");

const $0b2ff442787335c5$var$RoomDescAccordion = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("gVu4E")));

const $0b2ff442787335c5$var$AssociationAccordion = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("4tlAk")));

const $0b2ff442787335c5$var$PlotInfo = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("fXBwG")));

const $0b2ff442787335c5$var$AboutEstateAccordion = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("e7LFj")));

const $0b2ff442787335c5$var$LandAccordion = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("4GWov")));

const $0b2ff442787335c5$var$AboutAreaAccordion = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("l10EI")));

const $0b2ff442787335c5$var$EconomyAccordion = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("fe7jc")));

const $0b2ff442787335c5$var$DocumentAccordion = /*#__PURE__*/ (0, $dTCkE.lazy)(()=>(parcelRequire("fWqct")));
const $0b2ff442787335c5$export$cb5ac0ca7a85ff12 = ()=>{
    const { estate: data } = (0, $dTCkE.useContext)((0, $kqTTL.ObjectPageContext));
    const associationInfo = data?.associationInfo;
    const associationInfoArray = associationInfo && Object.values(associationInfo);
    const isEmpty = (value)=>value === null || value === 0 || Array.isArray(value) && value.length === 0; //check if array is empty
    const isCommercial = data?.estateTypeAsString == (0, $cUbQm.EstateType).Commercial;
    const isProject = data?.estateTypeAsString == (0, $cUbQm.EstateType).Project;
    const isFarm = data?.estateTypeAsString == (0, $cUbQm.EstateType).Agriculture;
    const isPlot = data?.estateTypeAsString == (0, $cUbQm.EstateType).Plot;
    (0, (/*@__PURE__*/$parcel$interopDefault($N2wHE))).locale("sv");
    return /*#__PURE__*/ (0, $a9eYm.jsxs)("div", {
        id: "facts",
        className: "m-auto my-6 px-0 lg:px-4 xxl:px-10 lg:my-16 flex flex-col gap-1",
        children: [
            data?.addressInfo?.streetAddress && data?.addressInfo?.streetAddress !== "-" && data?.estateTypeAsString !== (0, $cUbQm.EstateType).Project ? /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "hidden md:block font-icb text-3xl mb-4",
                children: data?.addressInfo?.streetAddress
            }) : null,
            data?.projectName && data?.estateTypeAsString == (0, $cUbQm.EstateType).Project && /*#__PURE__*/ (0, $a9eYm.jsx)("div", {
                className: "hidden md:block font-icb text-3xl mb-4",
                children: data?.projectName
            }),
            data?.estateTypeAsString !== (0, $cUbQm.EstateType).Plot && (data?.rooms && data?.rooms?.length > 0 || data?.otherResidentialBuildings?.length || data?.propertyBuildings?.length || data?.mainResidentialBuilding?.name) ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$RoomDescAccordion, {
                    isFarm: isFarm,
                    isCommercial: isCommercial,
                    label: `${isCommercial || isFarm ? (0, $hPa9t.General).Description : (0, $hPa9t.General).RoomDescription}`,
                    id: "description"
                })
            }) : null,
            isPlot ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$PlotInfo, {
                    label: (0, $hPa9t.General).AboutThePlot,
                    id: "description"
                })
            }) : /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$AboutEstateAccordion, {
                    isCommercial: isCommercial,
                    isProject: isProject,
                    label: `${isCommercial || isFarm ? (0, $hPa9t.General).AboutTheProperty : (0, $hPa9t.General).AboutTheHome}`,
                    id: "description"
                })
            }),
            (data?.lands && data?.lands.length > 0 || data?.arealData && data?.arealData.length > 0) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$LandAccordion, {
                    label: (0, $hPa9t.General).Land,
                    id: "lands"
                })
            }),
            (associationInfo && !associationInfoArray?.every(isEmpty) || associationInfo) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$AssociationAccordion, {
                    associationInfo: associationInfo,
                    label: (0, $hPa9t.Association).Association,
                    id: "housing",
                    wayDescription: data?.descriptions?.wayDescription
                })
            }),
            data?.addressInfo?.area && (data?.surrounding?.generalAboutArea || data?.surrounding?.communication || data?.surrounding?.nearService || data?.surrounding?.parking || data?.surrounding?.other) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$AboutAreaAccordion, {
                    label: `Om ${data?.addressInfo?.area ? data?.addressInfo?.area : "omr\xe5det"}`,
                    id: "area"
                })
            }),
            !isProject ? /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$EconomyAccordion, {
                    isFarm: isFarm,
                    isCommercial: isCommercial,
                    label: (0, $hPa9t.Economy).Economy,
                    id: "economy"
                })
            }) : null,
            (data?.documents.length || associationInfo?.documents.length > 0 || data?.links.length > 0) && /*#__PURE__*/ (0, $a9eYm.jsx)((0, $dTCkE.Suspense), {
                fallback: /*#__PURE__*/ (0, $a9eYm.jsx)((0, $a9eYm.Fragment), {}),
                children: /*#__PURE__*/ (0, $a9eYm.jsx)($0b2ff442787335c5$var$DocumentAccordion, {
                    label: (0, $hPa9t.General).DocumentAndLinks,
                    id: "documents"
                })
            })
        ]
    });
};
var $0b2ff442787335c5$export$2e2bcd8739ae039 = $0b2ff442787335c5$export$cb5ac0ca7a85ff12;

});
parcelRegister("gVu4E", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("9oVzY")).then(()=>parcelRequire("8WAam"));

});

parcelRegister("4tlAk", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3iND7")).then(()=>parcelRequire("bMqAB"));

});

parcelRegister("fXBwG", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("Ek8zm")).then(()=>parcelRequire("de9a4"));

});

parcelRegister("e7LFj", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cqbfm")).then(()=>parcelRequire("1Uluz"));

});

parcelRegister("4GWov", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("hnOFe")).then(()=>parcelRequire("iftds"));

});

parcelRegister("l10EI", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("iJNog")).then(()=>parcelRequire("aOKr6"));

});

parcelRegister("fe7jc", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("elUy4")).then(()=>parcelRequire("ew2eW"));

});

parcelRegister("fWqct", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("f6WGr")).then(()=>parcelRequire("j3RGk"));

});


parcelRegister("dIdpD", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("3HvxP")).then(()=>parcelRequire("kaHkc"));

});

parcelRegister("3b1hD", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("f9LKG")).then(()=>parcelRequire("e5L5F"));

});

parcelRegister("3lBXD", function(module, exports) {




module.exports = Promise.all([
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("crcNt")),
    (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("bg5Ph"))
]).then(()=>parcelRequire("5UKwK"));

});

parcelRegister("hngVL", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("a2ZZE")).then(()=>parcelRequire("gN0XY"));

});

parcelRegister("jcWdT", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("cCVxp")).then(()=>parcelRequire("9wkSI"));

});

parcelRegister("4YHAd", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("emKVP")).then(()=>parcelRequire("6MUZv"));

});

parcelRegister("hxN19", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("aO0HK")).then(()=>parcelRequire("9Tbze"));

});

parcelRegister("kXuE5", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("jmC17")).then(()=>parcelRequire("9Fxp1"));

});

parcelRegister("2z9Eg", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("9X18Y")).then(()=>parcelRequire("brcw1"));

});

parcelRegister("6PO0X", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("2vIFc")).then(()=>parcelRequire("gLiuA"));

});

parcelRegister("bIXEH", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("6niKx")).then(()=>parcelRequire("iPpEJ"));

});

parcelRegister("2xmJq", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("fBMhf")).then(()=>parcelRequire("l7quv"));

});

parcelRegister("8KLDQ", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("a6JMw")).then(()=>parcelRequire("iRwu7"));

});

parcelRegister("le8N8", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("6glMB")).then(()=>parcelRequire("kZA7P"));

});

parcelRegister("4DL9G", function(module, exports) {


module.exports = (parcelRequire("fj9RB"))((parcelRequire("i55FY")).resolve("joHb1")).then(()=>parcelRequire("dkm3C"));

});


})();
//# sourceMappingURL=ObjectPage.a079a436.js.map
